<template>
    <ValidationProvider
        :vid="vid"
        :name="$attrs.label"
        :rules="rules"
        :immediate="true"
        v-slot="{ errors, valid, dirty, touched }"
    >
        <b-field
            v-bind="$attrs"
            :class="{ 'hide-status-icon': (isRequired ? !(dirty || touched) : !(dirty || touched && !!innerValue)) }"
            :type="{
                'is-danger': isRequired && !valid,
                'is-success': isRequired ? (valid && (dirty || touched)) : true
            }"
            :message="isRequired && (dirty || touched) ? errors : []"
            :status-icon="!(isRequired ? !(dirty || touched) : !(dirty || touched && !!innerValue))"
        >
            <b-select
                :icon="$attrs.icon"
                :placeholder="$attrs.placeholder"
                :expanded="$attrs.expanded"
                :multiple="$attrs.multiple"
                v-model="innerValue"
                :status-icon="!(isRequired ? !(dirty || touched) : !(dirty || touched && !!innerValue))"
            >
                <slot />
            </b-select>
        </b-field>
    </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
	components: {
		ValidationProvider,
	},
	props: {
		vid: {
			type: String,
		},
		rules: {
			type: [Object, String],
			default: '',
		},
		// must be included in props
		value: {
			type: null,
		},
	},
	data: () => ({
		innerValue: null,
	}),
    computed: {
        isRequired() {
            if (!this.rules) return false;
            if (typeof this.rules === 'string') return this.rules.includes('required');
            if (typeof this.rules === 'object') return !!this.rules.required;
            return false;
        },
    },
	watch: {
		// Handles internal model changes.
		innerValue(newVal) {
			this.$emit('input', newVal);
		},
		// Handles external model changes.
		value(newVal) {
			this.innerValue = newVal;
		},
	},
	created() {
		if (this.value) {
			this.innerValue = this.value;
		}
	},
};
</script>

<style scoped>
.hide-status-icon >>> .icon.is-right { display: none !important; }
</style>
